export enum AdoptionComponent {
  AVATAR_ROUND = 'AvatarRound',
  AVATAR_SQUARE = 'AvatarSquare',
  BTN = 'Btn',
  BTN_V2 = 'BtnV2',
  LINK_BTN = 'LinkBtn',
  BUTTON_ROUND = 'ButtonRound',
  CARD = 'Card',
  AUTOCOMPLETE = 'Autocomplete',
  CHECKBOX = 'Checkbox',
  CALENDAR = 'Calendar',
  DATE_RANGE = 'DateRange',
  TIME = 'Time',
  FORM_CHOICE_FIELD = 'FormChoiceField',
  FORM_FIELD_CONTAINER = 'FormFieldContainer',
  FORM_FIELD_GROUP = 'FormFieldGroup',
  FORM_FIELD_LABEL_CONTAINER = 'FormFieldLabelContainer',
  FORM_FIELD_TEXT_BELOW = 'FormFieldTextBelow',
  NUMBER_INPUT = 'NumberInput',
  NUMBER_INPUT_V2 = 'NumberInputV2',
  RADIO = 'Radio',
  SELECT = 'Select',
  TEXT_AREA = 'TextArea',
  TEXT_INPUT = 'TextInput',
  TOGGLE = 'Toggle',
  HIGHLIGHTER = 'Highlighter',
  INDICATOR = 'Indicator',
  MODAL = 'Modal',
  POPOVER = 'Popover',
  LINK = 'Link',
  LIST = 'List',
  LOADER = 'Loader',
  LOZENGE = 'Lozenge',
  MAIN_NAVIGATION = 'MainNavigation',
  MAIN_NAVIGATION_ITEM = 'MainNavigationItem',
  SECTION_MESSAGE = 'SectionMessage',
  SEGMENTED_CONTROL = 'SegmentedControl',
  SKELETON_AVATAR = 'SkeletonAvatar',
  SKELETON_IMAGE = 'SkeletonImage',
  SKELETON_TEXT = 'SkeletonText',
  STATE_SCREEN = 'StateScreen',
  TABS = 'Tabs',
  TOAST = 'Toast',
  TOOLTIP_WRAPPER = 'TooltipWrapper',
  ICON = 'Icon',
}
